<template>
  <b-modal id="uploadPictureModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('buttons.uploadPicture') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-file name="picture" accept=".jpg, .png, .gif, .pdf, .doc, .docx" v-model="picture" :state="Boolean(picture)" :placeholder="$t('global.chooseImage')"></b-form-file>
      </b-col>
      <b-col>
        <b-form-checkbox
          id="isMain"
          v-model="isMain"
          name="checkbox-1"
          value="1"
          unchecked-value="0"
        >
          {{ $t('views.exsbitems.show.isMainPicture') }}
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-btn @click="submitFile()">{{ $t('buttons.submit') }}</b-btn>
        <b-button class="btn btn-danger" @click="closeModal()">{{ $t('buttons.close') }}</b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  name: 'UploadPictureModal',
  computed: {
    show () {
      return this.$store.state.modals.uploadPicture.show
    },
    path () {
      return this.$store.state.modals.uploadPicture.path
    },
    close () {
      return this.$store.state.modals.uploadPicture.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'path': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      picture: [],
      isMain: 1,
      uriPath: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.path) {
        this.uriPath = this.path.slice()
        this.$store.state.modals.uploadPicture.show = 0
        this.$store.state.modals.uploadPicture.path = null
        this.$bvModal.show('uploadPictureModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.uploadPicture.close = 0
      }
      this.$bvModal.hide('uploadPictureModal')
    },
    submitFile () {
      let formData = new FormData()
      formData.append('picture', this.picture)
      formData.append('isMain', this.isMain)
      this.$http.post(this.uriPath,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.$Swal({
          type: 'success',
          title: this.$t('notifications.update.updatedTitle'),
          timer: 2500
        })
        this.$emit('input', 1)
        this.closeModal()
      }).catch(error => {
        if (error.response.status === 400) {
          let text = error.response.data['hydra:description']
          this.$Swal({
            type: 'warning',
            title: text,
            timer: 2500
          })
        }
        console.log(error)
      })
    },
    handleFileUpload () {
      this.picture = this.$refs.file.files[0]
    },
    resetData () {
      this.uriPath = null
      this.picture = []
    }
  }
}
</script>
